module.exports = __webpack_public_path__ + "static/media/hot61.f5b34c47.jpg";